/**
 * The snippet inside a [[…]] wrapper (the engine's trim), or the snippet
 * itself. A transformer goes around the inner snippet.
 */
export const unwrapSnippet = (snippet: unknown): unknown =>
  Array.isArray(snippet) && Array.isArray(snippet[0]) && snippet[0].length > 0
    ? snippet[0][0]
    : snippet;
